import React from 'react'
import { Link } from 'gatsby'
import { dasherize } from '@/utilities'

const Receipt = ({ event, message }) => {
  const { title, paragraph } = message
  return (
    <div className="p-6">
      <h3>{title}</h3>
      <h4>{paragraph}</h4>
    </div>
  )
}

export default Receipt
